import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

if (import.meta.env.PROD && typeof window !== 'undefined' && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
  try {
    const hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    Object.defineProperty(hook, 'inject', { value: () => {}, writable: false });
  } catch {}
}

const queryClient = new QueryClient()

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
)
